import { RegisterOptions } from "react-hook-form";

type RegistrationFormValidationType = {
  [key: string]: RegisterOptions;
};

export const RegistrationFormValidation: RegistrationFormValidationType = {
  login: {
    // eslint-disable-next-line sonarjs/no-duplicate-string
    required: "profile.balance.deposit.input.validation.empty",
    pattern: {
      value:
        /^[a-zA-Z0-9.!#$%&'+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$/,
      message: "registration.error.email_invalid",
    },
  },
  password: {
    required: "profile.balance.deposit.input.validation.empty",
    minLength: {
      value: 6,
      message: "registration.password.error",
    },
  },
  currency: {
    required: "profile.balance.deposit.input.validation.empty",
  },
  checkboxes: {
    required: "profile.balance.deposit.input.validation.empty",
  },
};
